import { useRef } from 'react';
import { useState, useEffect } from 'react';

export function useDebounceFn<T extends (...args: any[]) => any>(callback: T, waitFor: number) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const debouncedFn = (...args: Parameters<T>) => {
    clearTimeout(timeoutRef.current);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, waitFor);
  };

  return debouncedFn;
}

export function useDebounceValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
